export const DELETE_LEAD_REQUEST = 'DELETE_LEAD_REQUEST';
export const DELETE_LEAD_REQUEST_SUCCESS = 'DELETE_LEAD_REQUEST_SUCCESS';
export const DELETE_LEAD_REQUEST_FAILURE = 'DELETE_LEAD_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/constants/delete_lead.constants.js